import { EGDSSpacing } from '@egds/react-core/spacing';
import * as React from 'react';
import { ErrorBoundary } from 'bernie-view';
import { PropertyLevelOffersCard } from '@shared-ui/lodging-property-offers';
import { withSharedUiPropertyOffers } from './shared-ui-property-offers';
const PropertyLevelOffersCardWrapper = ({
  inputs
}) => React.createElement(ErrorBoundary, {
  label: "PropertyLevelOffersCard"
}, React.createElement(EGDSSpacing, {
  margin: {
    small: {
      inline: 'three'
    },
    medium: {
      inline: 'unset'
    }
  }
}, React.createElement("div", null, React.createElement(PropertyLevelOffersCard, {
  inputs: inputs,
  showBorder: false,
  skipSsr: true
}))));
PropertyLevelOffersCardWrapper.displayName = 'PropertyLevelOffersCardWrapper';
export const SharedUiPropertyLevelOffersCardWrapper = withSharedUiPropertyOffers(PropertyLevelOffersCardWrapper);